<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $tc('add') }} {{ $tc('client', 1) }}</div>
      <router-link class="btn-blue" to="clients">{{$t('clients')}} {{ $tc('list',1) }}</router-link>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <!-- NAME -->
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_name"
                name="client_name"
                v-validate="'required'"
                v-model="client.client_name"
                placeholder="."
              />
              <label>{{ $t('client_name') }}</label>
            </div>
            <Tooltip :title="$t('client_name_tooltip')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('client_name')">{{ errors.first('client_name') }}</span>
          </p>
        </div>
        <!-- DESC -->
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_description"
                name="client_name"
                v-model="client.client_description"
                placeholder="."
              />
              <label>{{ $t('client_description') }}</label>
            </div>
            <Tooltip :title="$t('client_description_tooltip')" />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>
        <!-- PERSON NAME -->
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_contact_person_name"
                name="client_contact_person_name"
                v-validate="'alpha_spaces'"
                v-model="client.client_contact_person_name"
                placeholder="."
              />
              <label>{{ $t('client_contact_person_name') }}</label>
            </div>
            <Tooltip :title="$t('client_contact_person_name_tooltip')" />
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('client_contact_person_name')"
            >{{ errors.first('client_contact_person_name') }}</span>
          </p>
        </div>
        <!-- EMAIl ID -->
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_contact_person_email_id"
                name="client_contact_person_email_id"
                v-model="client.client_contact_person_email_id"
                v-validate="'email'"
                placeholder="."
              />
              <label>{{ $t('client_contact_person_email_id') }}</label>
            </div>
            <Tooltip :title="$t('client_contact_person_email_id_tooltip')" />
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('client_contact_person_email_id')"
            >{{ errors.first('client_contact_person_email_id') }}</span>
          </p>
        </div>
        <!-- MOBILE NUMBER -->
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material row">
              <div class="col-4">
                <b-dropdown
                  :text="client.country_mob_code ? client.country_mob_code : 'Code'"
                  variant="dropdown-curve"
                  class="w-100 text-center mr-3"
                  placeholder="code"
                  name="countrycode"
                  id="countrycode"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Code"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCode($event.target.value)"
                      v-on:keydown="onSearchCode($event.target.value)"
                      v-on:search="onSearchCode($event.target.value)"
                      v-model="searchCode"
                    />
                  </div>
                  <b-dropdown-item
                    href="#"
                    v-for="(countrycode, countryIndex) in countryList"
                    :key="countryIndex"
                    v-on:click="onSelectHandler('countrycode', countrycode)"
                    v-if="countrycode.country_mob_code != null"
                    >{{ countrycode.country_mob_code }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <div class="col-8 pl-1">
              <input
                id="client_contact_person_mobile_number"
                name="client_contact_person_mobile_number"
                v-model="client.client_contact_person_mobile_number"
                v-validate="'numeric|min:7'"
                placeholder="."
              />
              <label>{{ $t('client_contact_person_mobile_number') }}</label>
            </div>
            </div>
            <Tooltip :title="$t('client_contact_person_mobile_number_tooltip')" />
          </div>
          <p class="error_message">
            <span
              v-if="submitted && !client.country_mob_code"
            >{{ 'Country Code is Required.' }}</span>
            <span>{{' '}}</span>
            <span
              v-if="submitted && errors.has('client_contact_person_mobile_number')"
            >{{ errors.first('client_contact_person_mobile_number') }}</span>
          </p>
        </div>
        <!-- ADDRESS -->
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_address"
                name="client_address"
                v-model="client.client_address"
                placeholder="."
              />
              <label>{{ $t('client_address') }}</label>
            </div>
            <Tooltip :title="$t('client_address_tooltip')" />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t('active') }}</label>
            <label class="ios-switch">
              <input type="checkbox" class="ios-checkbox" v-model="client.client_is_active" />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button @click.prevent.stop="addClient(false)" class="btn-blue">{{ $t('save') }}</button>
        <button @click.prevent.stop="addClient(true)" class="btn-blue">{{ $t('saveaddmore') }}</button>
        <button @click.prevent.stop="resetClient()" class="btn-black">{{ $t('reset') }}</button>
        <b-button class="btn-outline-grey" variant="default" to="/master/clients">{{ $t('cancel') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ClientService from "@/services/ClientService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      submitted: false,
      client: {
        client_name: null,
        client_description: null,
        client_contact_person_name: null,
        client_contact_person_email_id: null,
        client_contact_person_mobile_number: null,
        client_address: null,
        client_is_active: true,
        country_mob_code: ""
      },
      searchCode: "",
      CodeListCopy: [],
      countryList: [],
      SelectedCountryCode: ""
    };
  },
  beforeMount() {
    this.getCountryList();
  },
  methods: {
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.countryList = this.CodeListCopy.filter(x => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.CodeListCopy;
      }
    },
    onSelectHandler(type, value, index) {
      if (type == "countrycode") {
        this.client.country_mob_code = value.country_mob_code;
        this.SelectedCountryCode = value.country_mob_code;
      }
    },
    getCountryList: function() {
      this.stateList = [];
      this.countryList = [];
      this.CodeListCopy = [];
      this.cityList = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.countryList = data.Records;
            this.CodeListCopy = data.Records;
          } else {
            console.log("show error1 :", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    resetClient: function () {
      this.client = {
        client_name: null,
        client_description: null,
        client_contact_person_name: null,
        client_contact_person_email_id: null,
        client_contact_person_mobile_number: null,
        client_address: null,
        client_is_active: true,
        country_mob_code: ''
      };
    },
    addClient(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          if(!this.client.country_mob_code) {
            return;
          }
          let payload = {
            ...this.client,
          };
          ClientService.CreatAClient(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(data.message);
                if (flag) {
                  this.resetClient();
                } else {
                  this.$router.push({
                    path: "/master/clients",
                  });
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>

    



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ClientComponent/addClient.vue